import React from 'react';

export interface IProps {
  name: string;

  onReset?: (arg1: boolean, name: string) => void;
}

const ClickFieldReset: React.FC<IProps> = React.memo(({ name, onReset }) => {
  const wOnReset = React.useCallback(() => {
    onReset?.(true, name);
  }, [name, onReset]);

  return (
    <span className="reset" onClick={wOnReset}>
      Reset
    </span>
  );
});

ClickFieldReset.displayName = 'ClickFieldReset';

export default ClickFieldReset;
